import React from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, UserPlus, Home, AlertTriangle } from "lucide-react";

const LABELS = { immediate: "Contatto immediato", scheduled: "Contatto programmato" };

export default function Conferma() {
  const location = useLocation();
  const navigate = useNavigate();
  const result = location.state?.result;

  if (!result) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center px-5 py-12">
      <div className="max-w-lg w-full bg-white rounded-3xl border border-gray-200 p-8 md:p-10 text-center animate-fade-up" data-testid="confirmation-card">
        <div className="w-16 h-16 rounded-full bg-[#FFFBEB] flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-9 h-9 text-[#10B981]" />
        </div>
        <h1 className="font-display text-2xl md:text-3xl font-bold tracking-tight">Richiesta inviata correttamente</h1>
        <p className="text-gray-600 mt-3">
          La segnalazione è stata registrata. Un operatore Dopopay contatterà il cliente secondo la modalità indicata.
        </p>

        {result.is_duplicate && (
          <div className="mt-5 text-sm bg-amber-50 border border-amber-200 text-amber-800 rounded-xl p-3 flex items-start gap-2 text-left" data-testid="duplicate-warning">
            <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
            <span>Attenzione: risulta già una segnalazione simile ({result.duplicate_of}). La richiesta è stata comunque registrata ed evidenziata agli operatori.</span>
          </div>
        )}

        <div className="mt-7 bg-[#F9FAFB] rounded-2xl border border-gray-200 p-5 text-left space-y-3 text-sm">
          <Row label="Numero richiesta" value={<span className="font-mono font-bold text-[#111111]" data-testid="request-code">{result.code}</span>} />
          <Row label="Ragione sociale" value={result.company_name} />
          <Row label="Modalità di contatto" value={LABELS[result.contact_mode]} />
          {result.preferred_date && <Row label="Data richiesta" value={`${result.preferred_date} · ${result.preferred_time_slot}`} />}
          <Row label="Agente segnalatore" value={result.agent_name} />
        </div>

        <div className="mt-8 grid sm:grid-cols-2 gap-3">
          <Button data-testid="new-request-btn" onClick={() => navigate("/")}
            className="h-12 rounded-xl bg-[#FFCC00] hover:bg-[#E6B800] text-black font-semibold transition-transform duration-200 hover:-translate-y-0.5">
            <UserPlus className="w-4 h-4 mr-1" /> Inserisci un altro cliente
          </Button>
          <Button data-testid="home-btn" variant="outline" onClick={() => navigate("/")}
            className="h-12 rounded-xl border-gray-300">
            <Home className="w-4 h-4 mr-1" /> Torna alla pagina iniziale
          </Button>
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between gap-4">
      <span className="text-gray-500">{label}</span>
      <span className="font-medium text-right">{value}</span>
    </div>
  );
}
